// 证件类型
export const cardTypeMap = [{
  text: '身份证',
  value: 1,
},
{
  text: '护照',
  value: 2,
},
{
  text: '军官证',
  value: 3,
},
{
  text: '出生证',
  value: 4,
},
{
  text: '外国人在华居住证',
  value: 6,
},
{
  text: '异常身份证',
  value: 7,
},
{
  text: '港澳回乡证',
  value: 8,
},
{
  text: '户口本',
  value: 9,
},
{
  text: '警官证',
  value: 10,
},
{
  text: '台胞证',
  value: 11,
},
{
  text: '驾驶证',
  value: 12,
},
{
  text: '其他',
  value: 5,
}];

// 订单状态
export const orderStatusMap = {
  STAY_PAY: 1, // 待付款
  STAY_DELIVER: 2, // 待提货, 待发货
  STAY_RECEIVE: 3, // 待收货
  STAY_EVALUATE: 4, // 待评价
  SUCCESS: 5, // 成功
  CLOSE: 6, // 交易关闭，已取消
  STAY_GROUP_BUY: 7, // 待成团
  STAY_PRESCRIBE: 8, // 待开方
  STAY_RECIPE_AUDIT: 9, // 待审方
  RECIPE_FAIL: 10, // 开方失败
  AUDIT_FAIL: 11, // 审方驳回
  O2O_SYNC_FAIL: 12, // o2o同步失败
  REFUND_FAIL: 13, // 退款失败
  DOSAGE: 20, // 配药中
};
